$ = jQuery;

const appRest = window.appRest || null;

$(document).ready(function($) {
    let loadMoreContainer = $('.load-more-container');
    let pageLinks = $('.pager a', loadMoreContainer);
    pageLinks.on( 'click', loadMore);

    function loadMore(e) {
        e.preventDefault();

        const url = appRest ? appRest.rest_endpoints.load_more: '';
        const postBody = {};
        postBody.link = $(e.target).attr('href');

        $.post({
            async: false,
            url: url,
            data: postBody,
            success: (wpRes) => {
                if('content' in wpRes) {
                    $('.posts-three-list-section', loadMoreContainer).replaceWith(wpRes.content);
                    pageLinks = $('.pager a', loadMoreContainer);
                    pageLinks.on( 'click', loadMore);
                }
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    let moreLink = $('.load-more', loadMoreContainer);
    moreLink.on( 'click', loadMoreCategory);

    function loadMoreCategory(e) {
        e.preventDefault();

        let container = $('.posts-two-list-section-wrapper ul');
        let postBody = e.target.dataset;

        const url = appRest ? appRest.rest_endpoints.load_more_category: '';
        $.post({
            async: false,
            url: url,
            data: postBody,
            success: (wpRes) => {
                if('content' in wpRes) {
                    container.append(wpRes.content);
                }

                if('next_page' in wpRes && wpRes.next_page !== false) {
                    e.target.dataset.page = wpRes.next_page;
                } else {
                    e.target.style.display = 'none';
                }
            },
            error: (err) => {
                console.log(err);
            },
        });
    }
});
